<template>
    <v-data-table
        class="text-center align-center"
        hide-default-footer
        mobile-breakpoint="400"
        :headers="headers"
        :items="productos"
        disable-sort
        :items-per-page="-1"
    >
        <template v-slot:[`item.precio`]="{ item }">
            <p v-if="precioConIva">{{ item.pr_vta | toCurrency }} <span>{{ ` más IVA (${porcentajeIva(item)}%)` }}</span></p>
            <p v-if="!precioConIva">{{ item.pr_final | toCurrency }}</p>
        </template>
        <template v-slot:[`item.cantidad`]="{ item }">
            <p>{{ descEmpaque(item) }}</p>
        </template>
    </v-data-table>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'DetalleCompraTabla',
    data() {
        return {
            headers: [
                { text: 'PRODUCTO', align: 'center', value: 'producto' },
                { text: 'CANTIDAD', align: 'center', value: 'cantidad' },
                { text: 'PRECIO POR UNIDAD', align: 'center', value: 'precio' }
            ]
        }
    },
    computed: {
        ...mapState(['usuario', 'carrito']),
        precioConIva() {
            return this.usuario.iva_id == 'MO' || this.usuario.iva_id == 'RI'
        },
        productos() {
            return this.carrito.map(item => ({
                producto: item.desc_cliente,
                cantidad: item.cantidad,
                cant_empaq: item.cant_empaq,
                pr_final: Math.round(item.pr_final + item.pr_final * (item.descuento / 100)),
                pr_vta: Math.round(item.pr_vta + item.pr_vta * (item.descuento / 100)),
                escala: item.escala,
                esc: item.esc,
                esc_plu: item.esc_plu,
                alq_cant_uso_diario: item.alq_cant_uso_diario
            }))
        }
    },
    methods: {
        descEmpaque(item) {
            let empaque = item.alq_cant_uso_diario || item.cant_empaq
            if (item.cantidad == 1) {
                if (item.escala != item.esc) {
                    return `${item.cantidad} ${item.escala} / ${item.cantidad * empaque} ${item.esc}`
                }
                return `${item.cantidad} ${item.escala}`
            }
            if (item.escala != item.esc) {
                return `${item.cantidad} ${item.esc_plu} / ${item.cantidad * empaque} ${item.esc}`
            }
            return `${item.cantidad} ${item.esc_plu}`
        },
        porcentajeIva(item) {
            let x = item.pr_final / item.pr_vta
            if (Math.abs(21 - (x - 1) * 100) < Math.abs(10.5 - (x - 1) * 100)) {
                return 21
            }
            return 10.5
        }
    }
}
</script>

<style scoped>
.v-data-table >>> thead {
    background-color: #ef6b01;
}
.theme--light.v-data-table >>> .v-data-table__wrapper > table > thead > tr > th {
    color: white;
}
</style>
